import { render, staticRenderFns } from "./querAfterSaleList.vue?vue&type=template&id=0b183e48&scoped=true"
import script from "./querAfterSaleList.vue?vue&type=script&lang=js"
export * from "./querAfterSaleList.vue?vue&type=script&lang=js"
import style0 from "./querAfterSaleList.vue?vue&type=style&index=0&id=0b183e48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b183e48",
  null
  
)

export default component.exports